<template>
  <div class="cart-detail">
    <div class="cart-thead">
      <div class="cart-th cart-one">选择商品</div>
      <div class="cart-th cart-two">商品信息</div>
      <div class="cart-th cart-three">单价（元）</div>
      <div class="cart-th cart-four">数量</div>
      <div class="cart-th cart-five">小计（元）</div>
      <div class="cart-th cart-six">操作</div>
    </div>
    <div class="cart-tbody">
      <div 
        class="cart-tr it-selected" 
        v-for="(prod, index) in cartInfo.prods" 
        :key="prod.cartId"
      >
        <div class="cart-td checksingle cart-one" @click="$emit('on-sel', index, prod)">
          <el-checkbox v-model="prod.checked"></el-checkbox>
        </div>
        <div class="cart-td pro-details cart-two">
          <div class="pic-box">
            <router-link :to="'/pages/plateform/productDetail?productId=' + prod.productId" target="_blank">
              <img :src="prod.coverPhoto" width="80" height="80" alt="">
            </router-link>
          </div>
          <div class="pro-describ">
            <router-link :to="'/pages/plateform/productDetail?productId=' + prod.productId" target="_blank">
              {{prod.prodName}}
            </router-link>
            <p>{{prod.prodDesc}}</p>
          </div>
        </div>
        <div class="cart-td cart-three">
          ￥<b class="g-price">{{prod.price}}</b>
        </div>
        <div class="cart-td cart-four btn-add-reduce">
          <el-button 
            class="reduce" 
            size="mini" 
            @click="$emit('minus-prod', prod)"
          >-</el-button>
          <el-input 
            type="number" 
            v-model.number="prod.cartNum" 
            class="pro-number" 
            min="1" 
            max="99"
            @blur="$emit('edit-prod', prod, prod.cartNum)"
          ></el-input>
          <el-button 
            class="add" 
            size="mini" 
            @click="$emit('add-prod', prod)"
          >+</el-button>
        </div>
        <div class="cart-td orange-bold cart-five">
          ￥<b class="subtotal">{{prod.cartNum * prod.price}}</b>
        </div>
        <div class="cart-td cart-six">
          <el-button 
            type="text" 
            class="removeGoods" 
            @click="$emit('del-prod', prod)"
          >删除</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartTable',
  props: {
    cartInfo: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.cart-thead {
  display: flex;
  padding: 10px 0;
  background: #f5f5f5;
  border-bottom: 1px solid #eee;
}
.cart-th {
  padding: 0 10px;
  text-align: center;
}
.cart-one { width: 10%; }
.cart-two { width: 30%; }
.cart-three { width: 10%; }
.cart-four { width: 20%; }
.cart-five { width: 10%; }
.cart-six { width: 10%; }

.cart-tbody {
  border-bottom: 1px solid #eee;
}
.cart-tr {
  display: flex;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #f5f5f5;
}
.cart-td {
  padding: 0 10px;
}
.pro-details {
  display: flex;
  align-items: center;
}
.pic-box {
  margin-right: 10px;
}
.pro-describ a {
  color: #333;
  text-decoration: none;
}
.pro-describ p {
  margin: 5px 0 0;
  color: #999;
  font-size: 12px;
}
.btn-add-reduce {
  display: flex;
  align-items: center;
}
.btn-add-reduce .el-button,
.btn-add-reduce .el-input {
  margin: 0 5px;
}
.pro-number {
  width: 60px;
}
.orange-bold {
  color: #ff6700;
  font-weight: bold;
}
.removeGoods {
  color: #999;
}
</style>